module.exports = __webpack_public_path__ + "static/media/扫码购.bd4d285f.png";